import {Component, Inject, Input, OnInit, DOCUMENT} from '@angular/core';

import {OAuthService} from 'angular-oauth2-oidc';
import {ActivatedRoute, Router} from '@angular/router';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Component({
  selector: 'app-auth-button',
  templateUrl: './auth-button.component.html',
  styles: [],
  standalone: false
})
export class AuthButtonComponent implements OnInit {

  private readonly log: AppLogger;

  isLoggedIn = false;
  @Input() returnUrl?: string;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private oauthService: OAuthService,
    private router: Router,
    private appLogger: AppLoggerService,
    private route: ActivatedRoute
  ) {
    this.log = this.appLogger.createForClass(AuthButtonComponent);
    this.isLoggedIn = this.oauthService.hasValidAccessToken();
  }

  login(): void {
    const target = this.returnUrl ?? this.router.url ?? '/home';
    sessionStorage.setItem('app:returnUrl', target);
    sessionStorage.setItem('app:loginInProgress', '1');
    this.oauthService.initCodeFlow(target);
  }

  logout(): void {
    this.oauthService.logOut();
  }

  ngOnInit(): void {
    this.log.debug('Auth button initialized', { isLoggedIn: this.isLoggedIn, returnUrl: this.returnUrl });
  }

}
